import ShoppingCartSave from '@/assets/icon_detail/shopping_cart_save.png';
import ShoppingCartSale from '@/assets/icon_detail/shopping_cart_sale.png';
import ShoppingCartCupon from '@/assets/icon_detail/shopping_cart_cupon.png';
import ShoppingCartFreeShipping from '@/assets/icon_detail/shopping_cart_free_shipping.png';
import ShoppingCartRedRight from '@/assets/icon_detail/shopping_cart_red_right.png';
import ShoppingCartBlueIcon from '@/assets/icon_detail/shopping_cart_blue.png';
import ShoppingCartBlueIcon2 from '@/assets/icon_detail/shopping_cart_blue2.png';
import ShoppingCartBlueRight from '@/assets/icon_detail/shopping_cart_blue_right.png';
import ShoppingCartRedIcon from '@/assets/icon_detail/shopping_cart_red.png';
import ShoppingCartRedIcon2 from '@/assets/icon_detail/shopping_cart_red2.png';

import FreeIcon from '@/assets/icon/free_icon.png';
import SaveIcon from '@/assets/icon/save_icon.png';
import SaleIcon from '@/assets/icon/sale_icon.png';
import CuponIcon from '@/assets/icon/cupon_icon.png';

import { $k18n } from '@/common/i18n';

// 和后端接口对齐：https://ecom-trade-c.staging.kuaishou.com/swagger-ui.html#/%E8%87%AA%E5%BB%BA%E8%B4%AD%E7%89%A9%E8%BD%A6API/stateUsingGET
export enum POINT_TYPE {
    SAVE = 4,
    FLASH_SALE = 5,
    CUPON = 6,
    FREE_SHIPPING = 7,
}

export const getMarketContents = (pointType: POINT_TYPE) => {
    const bgColor = { backgroundColor: 'rgba(255, 73, 6, 1)' };
    if (pointType === POINT_TYPE.SAVE) {
        return {
            leftWithoutBgIcon: SaveIcon,
            leftIcon: ShoppingCartSave,
            text: $k18n({ id: 'k_471256' }),
            rightIcon: ShoppingCartRedRight,
            bgColor,
            topCartIcon: ShoppingCartRedIcon,
            rightCartIcon: ShoppingCartRedIcon2,
        };
    }
    if (pointType === POINT_TYPE.FLASH_SALE) {
        return {
            leftWithoutBgIcon: SaleIcon,
            leftIcon: ShoppingCartSale,
            text: $k18n({ id: 'k_471255' }),
            rightIcon: ShoppingCartRedRight,
            bgColor,
            topCartIcon: ShoppingCartRedIcon,
            rightCartIcon: ShoppingCartRedIcon2,
        };
    }
    if (pointType === POINT_TYPE.CUPON) {
        return {
            leftWithoutBgIcon: CuponIcon,
            leftIcon: ShoppingCartCupon,
            text: $k18n({ id: 'k_471254' }),
            rightIcon: ShoppingCartRedRight,
            bgColor,
            topCartIcon: ShoppingCartRedIcon,
            rightCartIcon: ShoppingCartRedIcon2,
        };
    }
    if (pointType === POINT_TYPE.FREE_SHIPPING) {
        return {
            leftWithoutBgIcon: FreeIcon,
            leftIcon: ShoppingCartFreeShipping,
            text: $k18n({ id: 'k_471253' }),
            rightIcon: ShoppingCartBlueRight,
            bgColor: { backgroundColor: 'rgba(76, 167, 162, 1)' },
            topCartIcon: ShoppingCartBlueIcon,
            rightCartIcon: ShoppingCartBlueIcon2,
        };
    }
    return {
        leftWithoutBgIcon: null,
        leftIcon: null,
        text: '',
        rightIcon: null,
        bgColor,
        topCartIcon: ShoppingCartRedIcon,
        rightCartIcon: ShoppingCartRedIcon2,
    };
};
